
<div *ngIf="selectedProperty?.id == null">
  <mat-form-field appearance="outline" class="float-start">
    <input
      matInput
      type="text"
      placeholder="Search..."
      [(ngModel)]="propertyAddressFragment"
      (keyup)="propertyAddressFragmentChanged()"
      (paste)="onPaste($event)"
    />
  </mat-form-field>
  <mat-icon class="float-start mt-2"
    >search</mat-icon
  >
  <div
    class="search-results-wrapper d-inline-block w-100"
    *ngIf="loadingProperties || showNoPropertyFoundMessage || (properties != null && properties?.length > 0)"
    style="margin-top: -7px;"
  >
    <div class="search-results d-inline-block w-100 float-start">
      <mat-card class="mat-elevation-z0" *ngIf="loadingProperties">
        <app-table-data-loader></app-table-data-loader>
      </mat-card>
      <mat-card
        class="mat-elevation-z0"
        *ngIf="
          showNoPropertyFoundMessage &&
          this.propertyAddressFragment?.length >= 3
        "
        >Sorry no properties found matching address "{{
          propertyAddressFragment
        }}"...</mat-card
      >
      <div
        *ngIf="
          !loadingProperties && properties != null && properties?.length > 0
        "
      >
        <mat-action-list
          class="float-start d-flex align-items-center justify-content-between w-100"
          *ngFor="let property of properties"
        >
          <div
            class="d-flex justify-content-between align-items-center cursor-pointer"
            mat-list-item
            (click)="selectProperty(property)"
          >
            <div class="cursor-pointer w-100">{{ property.address }}</div>
          </div>
          <div
            class="float-start col-4 col-xl-2 d-flex h-100 justify-content-end align-items-center text-end"
          >
            <button
              class="common-button black mat-elevation-z0 me-2"
              mat-button
              mat-raised-button
              (click)="selectProperty(property)"
            >
              View
            </button>
          </div>
        </mat-action-list>
      </div>
    </div>
  </div>
</div>
<div *ngIf="selectedProperty?.id != null">
  <mat-form-field appearance="outline" class="float-start">
    <input
      matInput
      type="text"
      [(ngModel)]="selectedProperty.address"
      readonly="readonly"
      class="pt-0"
    />
  </mat-form-field>
  <mat-icon
    class="float-start"
    (click)="unselectProperty()"
    class="cursor-pointer mt-2"
    >close</mat-icon
  >
</div>
